module.exports = __webpack_public_path__ + "img/pi-4-2.0bedde7a.jpg";